import html2pdf from "html2pdf.js";
import { useEffect, useRef } from "react";
import logoImg from "../Assets/newLogo.png";
import "./CSS/PaymentInvoice.css";

const PaymentInvoice = ({
  handleDownloadPdf,
  dowloadPdf,
  invoiceId,
  customerdataname,
  customerInvoice,
}) => {
  const invoiceRef = useRef();
  const data = customerInvoice;
  console.log(data);
  // Function to download the invoice as a PDF
  const downloadPDF = () => {
    const element = invoiceRef.current;
    const options = {
      margin: 0.5,
      filename: "invoice.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 3, logging: true },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };

    // Using html2pdf to generate and download the PDF
    html2pdf().from(element).set(options).save();
  };
  useEffect(() => {
    if (dowloadPdf) {
      console.log("Triggering PDF download for Invoice:", invoiceId);
      downloadPDF(); // Trigger the download
      handleDownloadPdf(); // Reset the dowloadPdf state in the parent
    }
  }, [dowloadPdf, handleDownloadPdf, invoiceId]);

  return (
    <div className="card" ref={invoiceRef}>
      <div className="card-body p0">
        <div className="row justify-content-center" id="invoice">
          <div className="col-lg-12">
            <div className="shadow-4 border radius-8">
              <div className="invoice-container" ref={invoiceRef}>
                <div className="invoice-header">
                  <div className="invoice-details">
                    <h3 className="invoice-title">Invoice #{data.bph_id}</h3>
                    <p className="invoice-date">
                      Date Issued{" "}
                      {data.entry_date
                        ? new Date(data.entry_date).toLocaleDateString("en-GB")
                        : "null"}
                    </p>
                  </div>
                  <div className="invoice-info">
                    <img src={logoImg} alt="logo" className="invoice-logo" />
                    <p className="invoice-address">
                      2nd Floor, Gargi Rani Complex, Plot no. 96, Zone-II,
                      Maharana Pratap Nagar, Bhopal, Madhya Pradesh 462011
                    </p>
                    <p className="invoice-contact">
                      support@triosoft.ai, +91 1234567890
                    </p>
                  </div>
                </div>

                <div className="py-28 px-20">
                  <div className="d-flex flex-wrap justify-content-between align-items-end gap-3">
                    <div>
                      <h6 className="text-md">Issued For:</h6>
                      <table className="text-sm text-secondary-light">
                        <tbody>
                          <tr>
                            <td>Name</td>
                            <td className="ps-8">
                              {customerdataname?.full_name || "No Data"}
                            </td>
                          </tr>
                          <tr>
                            <td>Address</td>
                            <td className="ps-8">Bhopal</td>
                          </tr>
                          {customerdataname.mobile_no || customerdataname?.mobile_no !== "" &&
                          <tr>
                            <td>Phone number</td>
                            <td className="ps-8">
                              {" "}
                              {customerdataname?.mobile_no || "No Data"}
                            </td>
                          </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                    <div>
                      <table className="text-sm text-secondary-light">
                        <tbody>
                          <tr>
                            <td>Order ID</td>
                            <td className="ps-8">#{data.transaction_id}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="mt-24">
                    <div className="table-responsive scroll-sm">
                      <table className="table bordered-table text-sm">
                        <thead>
                          <tr>
                            <th scope="col" className="text-sm">
                              SL.
                            </th>
                            <th scope="col" className="text-sm">
                              Start Plan
                            </th>
                            <th scope="col" className="text-sm">
                              Plan
                            </th>
                            <th scope="col" className="text-sm">
                              Price
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {data && (
                            <tr>
                              <td>{"01"}</td>
                              <td>{data.start_date}</td>
                              <td>{data.package_name}</td>
                              <td>{data.package_amount}</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="d-flex flex-wrap justify-content-between gap-3">
                      <div>
                        {/* <p className="text-sm mb-0">
                          <span className="text-primary-light fw-semibold">
                            Sales By:
                          </span>{" "}
                          Jammal
                        </p> */}
                        <p className="text-sm mb-0">Thanks for your business</p>
                      </div>
                      <div>
                        <table className="text-sm">
                          <tbody>
                            <tr>
                              <td className="pe-64">Subtotal:</td>
                              <td className="pe-16">
                                <span className="text-primary-light fw-semibold">
                                  {data.pack_curency_icon}
                                  {data.package_amount}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td className="pe-64">Discount:</td>
                              <td className="pe-16">
                                <span className="text-primary-light fw-semibold">
                                  {data.pack_curency_icon}0.00
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td className="pe-64">Addons:</td>
                              <td className="pe-16">
                                <span className="text-primary-light fw-semibold">
                                  {data.pack_curency_icon}
                                  {data.add_on_price}
                                </span>
                              </td>
                            </tr>
                            {parseInt(data.igst_amount) !== 0 && (
                              <tr>
                                <td className="pe-64 pb-4">IGST@18%:</td>
                                <td className="pe-16 pb-4">
                                  <span className="text-primary-light fw-semibold">
                                    {data.pack_curency_icon}
                                    {data.igst_amount}
                                  </span>
                                </td>
                              </tr>
                            )}
                            {parseInt(data.cgst_amount) !== 0 && (
                              <tr>
                                <td className="pe-64 pb-4">CGST@9%:</td>
                                <td className="pe-16 pb-4">
                                  <span className="text-primary-light fw-semibold">
                                    {data.pack_curency_icon}
                                    {data.cgst_amount}
                                  </span>
                                </td>
                              </tr>
                            )}
                            {parseInt(data.sgst_amount) !== 0 && (
                              <tr>
                                <td className="pe-64 pb-4">SGST@9%:</td>
                                <td className="pe-16 pb-4">
                                  <span className="text-primary-light fw-semibold">
                                    {data.pack_curency_icon}
                                    {data.sgst_amount}
                                  </span>
                                </td>
                              </tr>
                            )}
                            <tr>
                              <td className="pe-64 border-top pt-4">
                                <span className="text-primary-light fw-semibold">
                                  Total:
                                </span>
                              </td>
                              <td className="pe-16 border-top pt-4">
                                <span className="text-primary-light fw-semibold">
                                  {data.pack_curency_icon}
                                  {data.total_price}
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="mt-64">
                    <p className="text-center text-secondary-light text-sm fw-semibold">
                      Thank you for your purchase!
                    </p>
                  </div>
                  <div className="d-flex flex-wrap justify-content-between align-items-end mt-64">
                    <div className="text-sm border-top d-inline-block px-12">
                      Signature of Customer
                    </div>
                    <div className="text-sm border-top d-inline-block px-12">
                      Signature of Authorized
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentInvoice;
